export default "__VITE_ASSET__C_vsG8G___"